<template lang="pug">
  v-text-field(v-if="!readonly" :label="label" ref="field" :value="value" :rules="[typeRule, lengthRule]" @change="validateInput")
  div(v-else-if="value")
    span.subheading.grey--text.text--darken-1 {{ label }} :
    div.pl-2 {{ value }}
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    maxChars: {
      type: Number,
      default: null,
    },
    valueId: {
      type: [Number, String],
      default: null,
    },
    attributeId: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      if (!value || value === '') {
        if (this.valueId) {
          this.$emit('delete', this.valueId);
        }
      } else {
        if (!this.valueId) {
          this.$emit('post', {attributeId: this.attributeId, value});
        } else {
          this.$emit('put', {valueId: this.valueId, value});
        }
      }
    },
    validateInput(value) {
      if (this.$refs.field.valid && value !== this.value) {
        this.handleChange(value);
      }
    },
  },
  computed: {
    lengthRule() {
      const max = this.maxChars;
      return value => (!max || value.length <= max) || `Ce champ est limité à ${max} caractères`;
    },
    typeRule() {
      switch (this.type) {
        case 'integer':
          return value => /^\d*$/.test(value) || 'Veuillez renseigner un nombre valide'
        case 'double':
          return value => /^(\d*(\.\d|,\d))?\d*$/.test(value) || 'Veuillez renseigner un nombre valide';
        default:
          return value => true;
      }
    },
  },
}
</script>

